import database from '@/utils/database'
import Vue from 'vue'

export const load = ({commit, state, rootGetters, dispatch}) => {
  return Vue.http.get('Platform/Destiny2/Manifest/')
    .then(({data}) => {
      commit('setLanguages', {languages: Object.keys(data.Response.mobileWorldContentPaths)})
      return database.load(data.Response.version + '-' + state.language,
        data.Response.mobileWorldContentPaths[state.language] + '?orgin=' + location.origin,
        (message) => {
          commit('destiny/setLoading', {loading: message}, {root: true})
        })
        .then((database) => {
          commit('setLoaded', {loaded: true})
        })
    })
}



// WEBPACK FOOTER //
// ./src/store/destiny/manifest/actions.js